import { request } from './client';
import type { FormQuestionInput, IFormQuestion } from '@/types/formQuestion';

// List questions for a publication
export const listPublicationQuestions = async (publicationId: string): Promise<{ data: IFormQuestion[] }> => {
  const response = await request('GET', `/v1/account/publications/${publicationId}/form/questions`, {});
  return response;
};

// Create a question for a publication
export const createPublicationQuestion = async (
  publicationId: string,
  questionData: Omit<FormQuestionInput, 'id'>
): Promise<{ data: IFormQuestion }> => {
  const response = await request('POST', `/v1/account/publications/${publicationId}/form/questions`, {}, questionData);
  return response;
};

// Update a question for a publication
export const updatePublicationQuestion = async (
  publicationId: string,
  questionId: number,
  questionData: FormQuestionInput
): Promise<{ data: IFormQuestion }> => {
  const response = await request(
    'PUT',
    `/v1/account/publications/${publicationId}/form/questions/${questionId}`,
    {},
    questionData
  );
  return response;
};

// Delete a question for a publication
export const deletePublicationQuestion = async (publicationId: string, questionId: number) => {
  const response = await request(
    'DELETE',
    `/v1/account/publications/${publicationId}/form/questions/${questionId}`,
    {}
  );
  return response;
};

// Reorder questions for a publication
export const reorderPublicationQuestions = async (publicationId: string, questionIds: number[]) => {
  const response = await request(
    'POST',
    `/v1/account/publications/${publicationId}/form/questions/reorder`,
    {},
    { ids: questionIds }
  );
  return response;
};

export function generateAiQuestion(publicationId: string, text: string): Promise<{ data: IFormQuestion }> {
  return request('POST', `/v1/account/publications/${publicationId}/form/questions/generate`, {}, { text });
}

export function getFormTaskStatus(
  pubkey: string,
  task: 'generate_questions'
): Promise<{
  data: IFormQuestion[];
  task: { status_string: 'in_progress' | 'success' | 'error' } | null;
}> {
  return request('GET', `/v1/account/publications/${pubkey}/form/tasks/${task}`);
}
